export default __webpack_public_path__ + "static/media/icon-mp4-file.714902ef.svg";